import * as fontUtils from './fontUtils';
import * as themeUtils from './themeUtils';
import * as configUtils from './config';
import { Ref } from 'vue';
import { GlobalConfig } from '../types/widget';

type CombinedUtils = typeof fontUtils & typeof themeUtils & typeof configUtils;

const utils: CombinedUtils = { ...configUtils, ...fontUtils, ...themeUtils };

export default utils;

export const config: Ref<GlobalConfig> = configUtils.config;
export const themeIcons = configUtils.themeIcons;
export const checkTheme = configUtils.checkTheme;
export const applyConfig = configUtils.applyConfig;
export const applyPublicConfig = configUtils.applyPublicConfig;
export const resetConfig = configUtils.resetConfig;
export const getClientTheme = configUtils.getClientTheme;
export const setWidgetInsuranceDetails = configUtils.setWidgetInsuranceDetails;
export const getWidgetType = configUtils.getWidgetType;
export const loadFonts = fontUtils.loadFonts;
export const applyTheme = themeUtils.applyTheme;
